import { useState, useEffect, useContext } from 'react';
import { Modal, Button, Input } from 'semantic-ui-react';
import styled from '@emotion/styled';
import UtilitiesServiceInstance from 'src/services/api/utilitiesService';
import { ListsContext } from 'src/services/contextProviders/lists/listsContext';
import { getLists } from 'src/services/contextProviders/lists/listsApiCall';

const ModalContainer = styled.div`
  .form-field {
    margin-bottom: 20px;
  }

  .form-field label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
  }

  .form-field input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }

  .form-field input:focus {
    outline: none;
    border-color: #2185d0;
    box-shadow: 0 0 0 2px rgba(34, 133, 208, 0.2);
  }

  .error {
    color: #db2828;
    font-size: 14px;
    margin-top: 5px;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
`;

const RelationsLimitsModal = ({ open, onClose, currentLimits }) => {
  const [inputs, setInputs] = useState({
    maleLimit: '',
    femaleLimit: '',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { set_data } = useContext(ListsContext);

  useEffect(() => {
    if (open && currentLimits) {
      setInputs({
        maleLimit: currentLimits?.male?.key || '',
        femaleLimit: currentLimits?.female?.key || '',
      });
      setErrors({});
    }
  }, [open, currentLimits]);

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!inputs.maleLimit || inputs.maleLimit <= 0) {
      newErrors.maleLimit = 'El límite de hombres debe ser mayor a 0';
    }

    if (!inputs.femaleLimit || inputs.femaleLimit <= 0) {
      newErrors.femaleLimit = 'El límite de mujeres debe ser mayor a 0';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await UtilitiesServiceInstance.updateListItem({
        id: currentLimits.male.id,
        key: parseInt(inputs.maleLimit),
      });
      await UtilitiesServiceInstance.updateListItem({
        id: currentLimits.female.id,
        key: parseInt(inputs.femaleLimit),
      });

      if (response.data.success) {
        getLists({ set_data });
        onClose();
      } else {
        throw new Error(response.data.message || 'Error al actualizar los límites');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setInputs({ maleLimit: '', femaleLimit: '' });
    setErrors({});
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} size="small">
      <Modal.Header>Cambiar Límites del Seminario de Relaciones Sanas</Modal.Header>
      <Modal.Content>
        <ModalContainer>
          <div className="modal-content">
            <p style={{ marginBottom: '20px', color: '#666' }}>
              Establece los límites de participantes para el seminario de relaciones sanas.
            </p>

            <div className="form-field">
              <label htmlFor="maleLimit">Límite de Hombres</label>
              <Input
                id="maleLimit"
                name="maleLimit"
                type="number"
                min="1"
                value={inputs.maleLimit}
                onChange={handleInputs}
                placeholder="Ingresa el límite de hombres"
                className={errors.maleLimit ? 'error' : ''}
              />
              {errors.maleLimit && <div className="error">{errors.maleLimit}</div>}
            </div>

            <div className="form-field">
              <label htmlFor="femaleLimit">Límite de Mujeres</label>
              <Input
                id="femaleLimit"
                name="femaleLimit"
                type="number"
                min="1"
                value={inputs.femaleLimit}
                onChange={handleInputs}
                placeholder="Ingresa el límite de mujeres"
                className={errors.femaleLimit ? 'error' : ''}
              />
              {errors.femaleLimit && <div className="error">{errors.femaleLimit}</div>}
            </div>

            <div className="modal-actions">
              <Button onClick={handleClose} disabled={loading}>
                Cancelar
              </Button>
              <Button primary onClick={handleSubmit} loading={loading} disabled={loading}>
                Actualizar Límites
              </Button>
            </div>
          </div>
        </ModalContainer>
      </Modal.Content>
    </Modal>
  );
};

export default RelationsLimitsModal;
